import r from "../../../utilities/tw.js";
const s = {
  base: r`size-3.5 rounded-full border p-0.5 text-success`,
  container: r`overflow-visible`,
  track: r`fill-transparent stroke-disabled stroke-1`,
  filler: r`fill-transparent stroke-primary stroke-2`
};
export {
  s as progressStyles
};
